import NoteTemplate from "../components/NoteTemplate";
import ButtonTemplate from "../components/ButtonTemplate";
import TemplateSelect from "../components/TemplateSelect";
import TextFieldTemplate from "../components/TextFieldTemplate";
import TemplateDateTimeControl from "../components/TemplateDatetime/TemplateDateTimeControl";
import TemplateMediaControl from "../components/TemplateMedia/TemplateMediaControl";

export const TEXT_QUESTION_TYPE = "text";
export const CALCULATE_QUESTION_TYPE = "calculate";
export const GROUP_QUESTION_TYPE = "group";


export const getTemplateGroup = (previewKey, state, language, questionId) => {
    previewKey = previewKey.indexOf("TEXT_TEMPLATE") >-1 ? "TEXT_TEMPLATE" : previewKey
    previewKey = previewKey.indexOf("SELECT_ONE_TEMPLATE") >-1 ? "SELECT_ONE" : previewKey
    previewKey = previewKey.indexOf("SELECT_MULTIPLE_TEMPLATE") >-1 ? "SELECT_MULTIPLE" : previewKey
    previewKey = previewKey.indexOf("BUTTON_TEMPLATE") >-1 ? "BUTTON" : previewKey
    
    switch (previewKey) {
        case "SINGLE_TEXT":
        case "TEXT_TEMPLATE":
            return <TextFieldTemplate key={questionId} questionId={questionId} language={language} />
  
        case "SELECT_ONE":
            return <TemplateSelect key={questionId} questionId={questionId} language={language} typeSelect="SELECT_ONE"/>
        
        case "SELECT_MULTIPLE":
            return <TemplateSelect key={questionId} questionId={questionId} language={language} typeSelect="SELECT_MULTIPLE"/>
        
        case "BUTTON":
            return <ButtonTemplate key={questionId} questionId={questionId} language={language}/>

        case "NOTE":
            return <NoteTemplate key={questionId} questionId={questionId} language={language}/>
        case "DATE":
        case "DATETIME":
        case "TIME":
            return <TemplateDateTimeControl key={questionId} questionId={questionId} language={language}/>
        case "IMAGE":
        case "AUDIO":
        case "VIDEO":
            return <TemplateMediaControl key={questionId} questionId={questionId} language={language}/>
        default:
            return <NoteTemplate key={questionId} questionId={questionId} language={language}/>
    }
  };
